var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchemesvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 491.001 491.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M470.3,337.05h-52.1v-93.8c0-11.5-9.4-20.9-20.9-20.9H265.9v-69.9H317c11.5,0,19.8-8.3,20.9-19.8V21.25 c0-11.5-9.4-20.9-20.9-20.9H173.1c-11.5,0-20.9,9.4-20.9,20.9v110.5c0,11.5,9.4,20.9,20.9,20.9h51.1v69.9H91.8 c-11.5,0-20.9,9.4-20.9,20.9v93.8h-50c-11.5,0-20.9,9.4-20.9,20.9v111.6c0,11.5,9.4,20.9,20.9,20.9h142.8 c11.5,0,20.9-9.4,21.9-20.9v-111.8c0-11.5-9.4-20.9-20.9-20.9h-52.1v-74h264.8v74h-51.1c-11.5,0-20.9,9.4-20.9,20.9v111.6 c0,11.5,9.4,20.9,20.9,20.9h142.8c11.5,0,20.9-9.4,21.9-20.9v-111.6C491.1,346.45,481.7,337.05,470.3,337.05z M194,41.05h103.2 v70.9H194V41.05z M144,449.65H40.7v-70.9h103.2v70.9H144z M449.4,449.65H346.2v-70.9h103.2V449.65z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchemesvg);
export default __webpack_public_path__ + "static/media/schemesvg.a8e99d688010d5c95c63a38247261841.svg";
export { ForwardRef as ReactComponent };